// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wWjD","left":"styles_left__2q-Hy"};